/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Close_Auto_Replace_ModalInputs */

const en_close_auto_replace_modal = /** @type {(inputs: Close_Auto_Replace_ModalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close Auto Replace modal`)
};

const fr_close_auto_replace_modal = /** @type {(inputs: Close_Auto_Replace_ModalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fermer la fenêtre Remplacement automatique`)
};

const de_close_auto_replace_modal = /** @type {(inputs: Close_Auto_Replace_ModalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatisches Ersetzen-Modal schließen`)
};

const it_close_auto_replace_modal = /** @type {(inputs: Close_Auto_Replace_ModalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiudi la modalità di sostituzione automatica`)
};

const ru_close_auto_replace_modal = /** @type {(inputs: Close_Auto_Replace_ModalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Закрыть модальное окно автозамены`)
};

const es_close_auto_replace_modal = /** @type {(inputs: Close_Auto_Replace_ModalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrar el modal de reemplazo automático`)
};

const zh_cn2_close_auto_replace_modal = /** @type {(inputs: Close_Auto_Replace_ModalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关闭自动替换模态框`)
};

const ja_close_auto_replace_modal = /** @type {(inputs: Close_Auto_Replace_ModalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自動置換モーダルを閉じる`)
};

const hi_close_auto_replace_modal = /** @type {(inputs: Close_Auto_Replace_ModalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑटो रिप्लेस मॉडल बंद करें`)
};

const pt_pt2_close_auto_replace_modal = /** @type {(inputs: Close_Auto_Replace_ModalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fechar modal de substituição automática`)
};

/**
* | output |
* | --- |
* | "Close Auto Replace modal" |
*
* @param {Close_Auto_Replace_ModalInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const close_auto_replace_modal = /** @type {((inputs?: Close_Auto_Replace_ModalInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Close_Auto_Replace_ModalInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_close_auto_replace_modal(inputs)
	if (locale === "de") return de_close_auto_replace_modal(inputs)
	if (locale === "it") return it_close_auto_replace_modal(inputs)
	if (locale === "ru") return ru_close_auto_replace_modal(inputs)
	if (locale === "es") return es_close_auto_replace_modal(inputs)
	if (locale === "zh-CN") return zh_cn2_close_auto_replace_modal(inputs)
	if (locale === "ja") return ja_close_auto_replace_modal(inputs)
	if (locale === "hi") return hi_close_auto_replace_modal(inputs)
	if (locale === "pt-PT") return pt_pt2_close_auto_replace_modal(inputs)
	return en_close_auto_replace_modal(inputs)
});